import { createFileRoute } from '@tanstack/react-router';
import { PageBody } from '@wundo/ui';
import { fetchCurrentUser } from '@wundo/client/auth.ts';
import { NotFoundPage } from '@/components/NotFoundPage.tsx';
import { JourneyDetailPage } from '@/components/journeys/JourneyDetailPage.tsx';
import { journeyDetailSearch } from '@/components/journeys/journeyDetailSearch.ts';
import { usePublishChatAnchor } from '@/lib/chatAnchor.ts';
import { loadOrNotFound } from '@/lib/loadOrNotFound.ts';
import { userJourneyQuery } from '@/lib/userJourneyQuery.ts';
import { m } from '@/paraglide/messages.js';

export const Route = createFileRoute('/_app/journeys/$journeyId')({
  /* The list's filters, carried along so the way back returns to the list as it was left, and the step to plan. */
  validateSearch: journeyDetailSearch,
  loader: ({ context, params }) =>
    loadOrNotFound(async () => {
      const user = await context.queryClient.ensureQueryData({
        queryKey: ['currentUser'],
        queryFn: fetchCurrentUser,
      });
      await context.queryClient.ensureQueryData(
        userJourneyQuery(user.id, params.journeyId),
      );
    }),
  /* Shown straight away, as the page's own loading line was before the loader. */
  pendingComponent: JourneyPending,
  pendingMs: 0,
  pendingMinMs: 0,
  notFoundComponent: NotFoundPage,
  component: JourneyRoute,
});

function JourneyPending() {
  return (
    <PageBody>
      <p className='text-base text-ink-muted'>{m.journey_loading()}</p>
    </PageBody>
  );
}

function JourneyRoute() {
  const { journeyId } = Route.useParams();
  const { plan, ...listSearch } = Route.useSearch();
  const navigate = Route.useNavigate();
  usePublishChatAnchor({ type: 'journey', id: journeyId });

  return (
    <JourneyDetailPage
      journeyId={journeyId}
      listSearch={listSearch}
      planStepId={plan}
      onPlanClose={() => void navigate({ search: listSearch, replace: true })}
    />
  );
}
